/* Hip + Joint Support Chews on the oc-ph-hw-v1 page layout. The packs are Kaching deal I-cX on one variant: Buy 1 Jar
   (quantity break), Buy 2, Get 1 Free and Buy 3, Get 2 Free (Buy X, Get Y, each with the free Hip & Joint Support Guide).
   The bars' "specific" prices sit above the Shopify price, so a pack costs the paid jars at the variant's price, or its
   selling plan's price when subscribing. Each pack goes in as Kaching's own lines, sharing one random Kaching id: the
   paid jars, the free jars (made $0 by Kaching's Bundle Savings) and the guide (price 0). Line format checked with real
   adds on 28 Oct 2026. The deal is re-read live through the Kaching SDK so a bar edit in Kaching reaches this page. */
(() => {
  'use strict';
  const root = document.querySelector('[data-oc-hw-native]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-hw-config]').textContent);
  const decoder = document.createElement('textarea');
  Object.keys(cfg.strings).forEach(key => {decoder.innerHTML=cfg.strings[key];cfg.strings[key]=decoder.value;});
  const params = new URLSearchParams(location.search);
  const form = root.querySelector('[data-hw-purchase]');
  const button = form.querySelector('[data-hw-add]');
  const label = button.querySelector('[data-hw-add-label]');
  const offerRoot = root.querySelector('[data-hw-offers]');
  const status = root.querySelector('[data-hw-status]');
  const toggle = root.querySelector('[data-hw-mode]');
  const radios = [...root.querySelectorAll('[name="oc-hw-pack"]')];
  let mode = 'subscription', busy = false, uncertain = false;
  const dealError = 'This offer could not be loaded. Refresh the page and try again.';

  // Deal bars from the section (Kaching deal I-cX as read on 28 Oct 2026), replaced by the live deal once the SDK loads.
  let deal = cfg.deal;
  const startDealEngine = async () => {
    const app = document.getElementById('kaching-bundles-config');
    const settings = app && JSON.parse(app.textContent);
    if (!settings?.storefrontAccessToken) return;
    await import(cfg.bundleSdk);
    const widget = document.createElement('kaching-bundle-component');
    widget.setAttribute('aria-hidden','true');
    widget.setAttribute('inert','');
    widget.hidden = true;
    for (const [key,value] of Object.entries({
      'shop-domain':settings.shopifyDomain,
      'storefront-token':settings.storefrontAccessToken,
      'product-id':String(cfg.productId),
      'deal-block-id':cfg.deal.blockId,
      'selected-variant-id':String(cfg.variant.id),
      country:cfg.country,language:'EN'
    })) widget.setAttribute(key,value);
    const loaded = new Promise((resolve,reject) => {
      const timer = setTimeout(()=>reject(new Error(dealError)),15000);
      widget.addEventListener('loaded',()=>{clearTimeout(timer);resolve();},{once:true});
    });
    root.append(widget);
    await loaded;
    const live = JSON.parse(widget.querySelector('kaching-bundles-block')?.getAttribute('deal-block') || 'null');
    widget.remove();
    const idOf = gid => Number(String(gid||'').split('/').pop())||null;
    const bars = {};
    for (const bar of live?.dealBars || []) {
      if (bar.dealBarType === 'quantity-break' && Number(bar.quantity) === 1) bars[1] = {id:bar.id, buy:1, get:0, gift:null};
      if (bar.dealBarType === 'bxgy' && [2,3].includes(Number(bar.buyQuantity))) {
        const gift = (bar.freeGifts || [])[0];
        if (gift && idOf(gift.productGID || gift.productId) !== cfg.guide.productId) throw new Error(dealError);
        bars[bar.buyQuantity] = {id:bar.id, buy:Number(bar.buyQuantity), get:Number(bar.getQuantity)||0, gift:gift?.id || null};
      }
    }
    if (!live?.nanoId || Object.keys(bars).length !== 3 || !(bars[2].get > 0 && bars[3].get > 0)) throw new Error(dealError);
    deal = {...cfg.deal, nanoId:live.nanoId, bars};
    root.dataset.hwDealLive = 'true';
    if(params.get('oc_qa')==='1')root.dataset.hwDeal=JSON.stringify(deal);
    render();
  };

  const formatter = new Intl.NumberFormat('en-US', {style:'currency',currency:cfg.currency});
  const money = cents => formatter.format(cents / 100);
  const reference = cfg.variant.compareAt > cfg.variant.price ? cfg.variant.compareAt : cfg.variant.price;
  const plan = cfg.plans.find(p => p.id === cfg.planId) || null;
  const unit = () => mode === 'once' ? cfg.variant.price : plan?.price;
  const jarsIn = bar => bar.buy + bar.get;
  const amountFor = bar => bar.buy * unit();
  root.querySelectorAll('.product-info .review-product-title + .product-price').forEach(value => {value.textContent = money(cfg.variant.price);});
  const giftCurrency = window.Shopify?.currency;
  const giftRate = cfg.currency === 'USD' ? 1 : Number(giftCurrency?.rate);
  const giftFormatter = new Intl.NumberFormat('en-' + cfg.country, {
    style: 'currency', currency: cfg.currency, currencyDisplay: 'narrowSymbol'
  });
  const showValue = (node, cents) => {
    node.textContent = giftFormatter.format(cents / 100);
    node.setAttribute('aria-label', node.textContent + ' ' + cfg.currency + ' gift value');
    node.hidden = false;
  };
  // The guide's value is its compare-at price in USD, converted at the market rate.
  if (cfg.baseCurrency === 'USD' && giftCurrency?.active === cfg.currency && Number.isFinite(giftRate) && giftRate > 0) {
    root.querySelectorAll('[data-hw-gift-value]').forEach(value => showValue(value, Math.round(Number(value.dataset.hwGiftValue) * giftRate)));
  }
  const endpoint = suffix => cfg.root.replace(/\/$/,'') + '/cart/' + suffix;
  const cartEndpoint = cfg.root.replace(/\/$/,'') + '/cart.js';
  const selected = () => Number(radios.find(r => r.checked)?.value) || 0;
  const announce = message => { status.textContent = message; };
  const cartCount = cart => document.querySelectorAll('[data-hw-cart-count]').forEach(n => {const value=String(cart.item_count);if(n.textContent!==value)n.textContent=value;});
  // The store-wide cart drawer (snippets/oc-cart, rendered by this layout) opens with a cart we already read.
  const openCart = cart => {
    if (window.ocCart) return window.ocCart.open(cart);
    location.assign(cfg.root.replace(/\/$/,'') + '/cart');
  };
  const loadCart = async () => {
    const response = await fetch(cartEndpoint, {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error(cfg.strings.cartCheck);
    return response.json();
  };
  const post = async (path,body) => {
    const response = await fetch(endpoint(path), {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || cfg.strings.error);
    return data;
  };
  function marketUrl() {
    const url = new URL(location.href);
    url.searchParams.set('view',cfg.view);
    url.searchParams.delete('country');
    return url.pathname + url.search;
  }
  const marketForm = document.getElementById('oc-hw-market');
  const mobileMenu = document.querySelector('.oc-hw-mobile-nav');
  const mobileMarket = document.querySelector('[data-hw-mobile-market]');
  const desktopMarket = document.querySelector('[data-hw-desktop-market]');
  const mobileHeader = matchMedia('(max-width: 989px)');
  const placeMarket = () => {
    const destination = mobileHeader.matches ? mobileMarket : desktopMarket;
    if (marketForm && destination && marketForm.parentElement !== destination) destination.append(marketForm);
    if (!mobileHeader.matches && mobileMenu) mobileMenu.open = false;
  };
  placeMarket();
  mobileHeader.addEventListener('change',placeMarket);
  mobileMenu?.addEventListener('keydown',event => {
    if (event.key === 'Escape' && mobileMenu.open) {
      mobileMenu.open = false;
      mobileMenu.querySelector('summary').focus();
    }
  });
  const countrySelect = marketForm?.querySelector('[data-hw-country]');
  countrySelect?.addEventListener('change', () => {
    marketForm.querySelector('[data-hw-market-return]').value = marketUrl();
    marketForm.submit();
  });
  if (cfg.requiredCountry && cfg.country !== cfg.requiredCountry && !window.Shopify?.designMode) {
    button.disabled = true;
    if (countrySelect && [...countrySelect.options].some(o => o.value === cfg.requiredCountry)) {
      countrySelect.value = cfg.requiredCountry;
      marketForm.querySelector('[data-hw-market-return]').value = marketUrl();
      marketForm.submit();
    } else announce('This country is not available in the store.');
    return;
  }
  const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;
  function render() {
    const ready = !!deal?.bars?.[1] && Number.isFinite(unit());
    radios.forEach(radio => {
      const bar = deal.bars[Number(radio.value)];
      const available = ready && cfg.variant.available && !!bar && (mode === 'once' || !!plan);
      const node = radio.closest('[data-oc-bottles]');
      node.classList.toggle('kaching-bundles__bar--selected',radio.checked);
      radio.disabled = !available || busy || uncertain;
      if (!available) return;
      const amount = amountFor(bar), jars = jarsIn(bar);
      // Savings and the per-jar price count every jar in the pack, free ones included; the total shows what is paid.
      const save = Math.floor((1-amount/(reference*jars))*100);
      node.querySelector('[data-hw-save]').textContent = save>0 ? `You save ${save}%` : '';
      const each = node.querySelector('[data-hw-each]');
      each.replaceChildren(document.createTextNode(money(amount/jars)+' '));
      const per = document.createElement('span');per.className='kaching-bundles__bar-price__unit-label';per.textContent='per jar';each.append(per);
      each.setAttribute('aria-label',money(amount/jars)+' per jar');
      node.querySelector('[data-hw-reference]').textContent=money(reference);
      const total=node.querySelector('[data-hw-total]');if(total)total.textContent=`${plural(jars,'jar')}, total: ${money(amount)}`;
    });
    const bar=deal.bars[selected()],amount=ready&&bar?amountFor(bar):0;
    form.querySelector('[data-hw-variant]').value=String(cfg.variant.id);
    form.querySelector('[name="quantity"]').value=String(bar?.buy||1);
    const input=form.querySelector('[data-hw-plan]');input.disabled=mode==='once';input.value=mode==='once'?'':String(plan?.id || '');
    toggle.textContent=mode==='subscription'?cfg.strings.once:cfg.strings.subscribe;
    toggle.setAttribute('aria-pressed',String(mode==='once'));
    const renewal=root.querySelector('[data-hw-renewal]');
    if(ready&&bar)renewal.textContent=(mode==='once'?`One-time purchase: ${money(amount)} for ${plural(jarsIn(bar),'jar')}. No recurring charges.`:`Subscribe & save: ${money(amount)} today for ${plural(jarsIn(bar),'jar')}, then delivered every month. ${cfg.strings.cancel}`)+` One jar lasts ${cfg.chewsPerJar/cfg.dailyChews} days at 2 chews a day. Prices in ${cfg.currency}.`;
    root.querySelectorAll('[data-hw-gift]').forEach(tile => {
      const minimum=Number(tile.dataset.hwGift),open=!!bar&&bar.buy>=minimum,key=tile.dataset.hwGiftKey;
      const title=tile.querySelector('.kaching-bundles__progressive-gifts__gift__title');
      tile.classList.toggle('oculabs-gift--locked',!open);
      tile.dataset.ocGiftLocked=String(!open);
      if(key==='free-jars'){
        const get=open?bar.get:deal.bars[minimum]?.get||1;
        title.textContent=`${get} FREE ${get===1?'Jar':'Jars'}`;
        const value=tile.querySelector('[data-hw-gift-jars]');if(value)showValue(value,get*cfg.variant.price);
      }
      tile.setAttribute('aria-label',title.textContent+(open?'. Included with this pack':`. Unlocks with Buy ${minimum}`));
      tile.querySelector('.oculabs-gift-note').textContent=open?({shipping:'On every order',guide:'Digital guide','free-jars':'In your pack'})[key]||'':`Unlocks with Buy ${minimum}`;
    });
    button.disabled=busy||uncertain||!ready||!cfg.variant.available||!bar||(mode==='subscription'&&!plan);
    toggle.disabled=busy||uncertain;
    label.textContent=busy?cfg.strings.adding:cfg.strings.add;
    offerRoot.style.visibility='visible';
    root.dataset.hwMode=mode;root.dataset.hwReady=String(!button.disabled);
  }
  radios.forEach(r => r.addEventListener('change',render));
  toggle.addEventListener('click',() => {mode=mode==='subscription'?'once':'subscription';render();});
  root.querySelectorAll('[data-hw-gift]').forEach(tile => {
    const choose=() => {if(busy||uncertain)return;const r=radios.find(x=>Number(x.value)===Number(tile.dataset.hwGift));if(r&&!r.disabled){r.checked=true;render();}};
    tile.addEventListener('click',choose);tile.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();choose();}});
  });
  function lineProperties() {
    const properties={_oc_hip_page:cfg.pageVersion,_oc_market:cfg.country};
    for(const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term']){const value=params.get(key);if(value)properties['_'+key]=value.slice(0,150);}
    if(params.get('oc_qa')==='1')properties._oc_qa=cfg.pageVersion;
    return properties;
  }
  // Kaching's own bundle id: 4 random URL-safe characters, shared by every line of one pack.
  const kachingId=()=>{const abc='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';const bytes=new Uint8Array(4);crypto.getRandomValues(bytes);return [...bytes].map(b=>abc[b&63]).join('');};
  function bundleItems(bar,p,id) {
    const base={...lineProperties(),_oc_hip_group:id};
    const paid={deal:deal.nanoId,pp:cfg.productId,main:true,id,bar:bar.id};
    if(p)paid.sellingPlan={id:p.id,priceAdjustment:{type:'percentage',value:p.adjustment}};
    const items=[{id:cfg.variant.id,quantity:bar.buy,properties:{...base,__kaching_bundles:JSON.stringify(paid)}}];
    if(bar.get)items.push({id:cfg.variant.id,quantity:bar.get,properties:{...base,__kaching_bundles:JSON.stringify({id,deal:deal.nanoId,bar:bar.id,main:true,bxgy:true})}});
    if(p)items.forEach(item=>{item.selling_plan=p.id;});
    if(bar.gift)items.push({id:cfg.guide.variantId,quantity:1,properties:{_oc_hip_group:id,__kaching_bundles:JSON.stringify({id,deal:deal.nanoId,gift:bar.gift})}});
    return items;
  }
  form.addEventListener('submit',async event => {
    event.preventDefault();if(button.disabled||busy||uncertain)return;
    busy=true;announce('');render();
    const bar=deal.bars[selected()],p=mode==='once'?null:plan,id=kachingId();
    const items=bundleItems(bar,p,id);
    if(params.get('oc_qa')==='1')root.dataset.hwSubmitItems=JSON.stringify(items);
    let submitted=false,added=false;
    const inGroup=line=>line.properties?._oc_hip_group===id;
    const isJar=line=>inGroup(line)&&line.variant_id===cfg.variant.id;
    const kaching=line=>{try{return JSON.parse(line.properties?.__kaching_bundles||'null')||{};}catch{return {};}};
    const unitPrice=p?p.price:cfg.variant.price;
    try{
      const baseline=await loadCart();
      if(baseline.currency!==cfg.currency)throw new Error('Your currency changed. Refresh the page before adding this supply.');
      submitted=true;
      await post('add.js',{items});
      added=true;
      const cart=await loadCart();
      const lines=cart.items.filter(inGroup);
      const planOk=line=>String(line.selling_plan_allocation?.selling_plan?.id||'')===String(p?.id||'');
      const paid=lines.find(l=>isJar(l)&&!kaching(l).bxgy),free=lines.find(l=>isJar(l)&&kaching(l).bxgy),gift=lines.find(l=>l.variant_id===cfg.guide.variantId);
      const ok=cart.currency===cfg.currency&&paid&&paid.quantity===bar.buy&&planOk(paid)&&paid.original_price===unitPrice&&paid.final_line_price===unitPrice*bar.buy
        &&(!bar.get||(free&&free.quantity===bar.get&&planOk(free)&&free.final_line_price===0))
        &&(!bar.gift||(gift&&gift.quantity===1&&gift.final_line_price===0))
        &&lines.length===1+(bar.get?1:0)+(bar.gift?1:0);
      if(!ok){
        // Take this pack out again by position in a fresh cart: Kaching rewrites same-deal lines, so keys shift.
        let rollback=null;
        for(let guard=0;guard<12;guard++){const fresh=await loadCart();const index=fresh.items.findIndex(inGroup);if(index<0)break;rollback=await post('change.js',{line:index+1,quantity:0});}
        const restored=rollback||await loadCart();
        if(restored.items.some(inGroup))throw new Error(cfg.strings.cartCheck);
        cartCount(restored);added=false;submitted=false;
        throw new Error('This pack could not be priced correctly, so nothing was added. Please refresh and try again.');
      }
      cartCount(cart);openCart(cart);announce(cfg.strings.added);
      if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.())window.dataLayer?.push({event:'oc_hip_add_to_cart',page:cfg.pageVersion,bar:selected(),jars:jarsIn(bar),plan_type:p?'subscription':'one-time',currency:cfg.currency,qa:params.get('oc_qa')==='1'});
    }catch(error){
      // A timeout can come after Shopify accepted the items. Check the saved cart before allowing another
      // click, so a retry cannot double an order.
      if(submitted){
        try{const cart=await loadCart();added=added||cart.items.some(inGroup);cartCount(cart);uncertain=added&&!cart.items.some(isJar);}
        catch{uncertain=true;}
      }
      announce(uncertain?cfg.strings.cartCheck:error instanceof TypeError?cfg.strings.error:error.message||cfg.strings.error);
      if(uncertain||added){const link=document.createElement('a');link.href=cfg.root.replace(/\/$/,'')+'/cart';link.textContent=' View cart';status.append(link);}
    }finally{busy=false;render();}
  });
  document.querySelectorAll('[data-hw-cart]').forEach(button=>button.addEventListener('click',()=>openCart()));
  window.addEventListener('pageshow',e=>{if(e.persisted)location.reload();});
  const loadImage=img=>{if(img?.dataset.src){img.src=img.dataset.src;if(img.dataset.srcset)img.srcset=img.dataset.srcset;delete img.dataset.src;delete img.dataset.srcset;}};
  const formula=root.querySelector('#oc-hw-formula'),feeding=root.querySelector('#oc-hw-feeding'),zoom=root.querySelector('#oc-hw-zoom');
  // Safari before iOS 15.4 has no <dialog>: hide these three pop-ups until opened and open/close them by hand there.
  [formula,feeding,zoom].forEach(d=>{if(!d||typeof d.showModal==='function')return;if(!document.getElementById('oc-dialog-fallback')){const st=document.createElement('style');st.id='oc-dialog-fallback';st.textContent='#oc-hw-formula:not([open]),#oc-hw-feeding:not([open]),#oc-hw-zoom:not([open]){display:none}#oc-hw-formula[open],#oc-hw-feeding[open],#oc-hw-zoom[open]{position:fixed;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:2147483000;margin:0;max-height:88vh;overflow:auto;box-shadow:0 0 0 100vmax rgba(11,30,57,.7)}';document.head.appendChild(st);}d.showModal=()=>d.setAttribute('open','');d.close=()=>d.removeAttribute('open');});
  const formulaArtwork=root.querySelector('.shop-main-image[data-media-id="oc-hip-10"]')||root.querySelectorAll('.shop-main-image')[3];
  const showFormula=()=>{const img=formula.querySelector('[data-hw-formula-image]');img.src=formulaArtwork.dataset.zoomSrc||formulaArtwork.dataset.src||formulaArtwork.src;img.alt=formulaArtwork.alt;};
  root.querySelectorAll('[data-hw-open]').forEach(button=>button.addEventListener('click',()=>{const dialog=button.dataset.hwOpen==='formula'?formula:feeding;if(dialog===formula)showFormula();else dialog.querySelectorAll('img').forEach(loadImage);dialog.showModal();dialog.querySelector('[data-hw-close]').focus();}));
  [formula,feeding,zoom].forEach(dialog=>{dialog.querySelector('[data-hw-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});});
  root.querySelector('.shop-main-image-wrapper')?.addEventListener('click',e=>{if(e.target.closest('button,a'))return;const active=root.querySelector('.shop-main-image.active');if(!active)return;const img=zoom.querySelector('img');img.src=active.dataset.zoomSrc||active.src;img.alt=active.alt;zoom.showModal();});
  // Keep FAQ paragraphs intact and expose the existing accordion to keyboards.
  root.querySelectorAll('.faq-question').forEach(question=>{const item=question.closest('.faq-item');question.tabIndex=0;question.setAttribute('role','button');const syncExpanded=()=>{const expanded=String(item.classList.contains('active'));if(question.getAttribute('aria-expanded')!==expanded)question.setAttribute('aria-expanded',expanded);};const faqObserver=new MutationObserver(syncExpanded);faqObserver.observe(item,{attributes:true,attributeFilter:['class']});faqObserver.observe(question,{attributes:true,attributeFilter:['aria-expanded']});syncExpanded();question.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();question.click();}});});
  root.querySelectorAll('.shop-thumbnail').forEach((thumb,i)=>{thumb.tabIndex=0;thumb.setAttribute('role','button');thumb.setAttribute('aria-label',`View product image ${i+1}`);thumb.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();thumb.click();}});});
  const gallerySurface=root.querySelector('.shop-main-image-wrapper');
  if(gallerySurface){
    [-1,1].forEach(direction=>{
      const arrow=document.createElement('button');arrow.type='button';
      arrow.className='oc-hw-gallery-arrow '+(direction<0?'prev':'next');
      arrow.setAttribute('aria-label',direction<0?'Previous product image':'Next product image');
      arrow.textContent=direction<0?'‹':'›';
      arrow.addEventListener('click',()=>{
        const dots=[...root.querySelectorAll('.shop-dot')];
        const index=[...root.querySelectorAll('.shop-main-image')].findIndex(img=>img.classList.contains('active'));
        dots[(index+direction+dots.length)%dots.length]?.click();
      });
      gallerySurface.append(arrow);
    });
  }
  render();
  startDealEngine().catch(error=>{
    // The section's copy of the deal still works; the add check catches a Kaching edit it does not know about.
    root.dataset.hwDealLive='false';if(params.get('oc_qa')==='1')root.dataset.hwDealError=String(error?.message||error);
  });
})();
